<section class=" container px-0 py-2" *ngIf="current">
  <form class="pb-2 mb-2 border-bottom no-wrap">
    <div class="d-flex align-items-center mb-1 overflow-auto">
      <div class="mx-1">
        <input class="py-1" style="min-width:100px" type="search" placeholder="جستجو" name="keyword"
          [(ngModel)]="keyword" (change)="load()">
      </div>
      <div class="flex-fill d-flex align-items-center mx-1">
        <label class="d-flex align-items-center mx-1" *ngIf="current.Operator.AccessRights.includes('ManageUsers')">
          <input type="checkbox" name="operator" [(ngModel)]="roles['Operator']" (change)="load()">اپراتور</label>
        <div class="mx-1">
          <label class="d-flex align-items-center mx-1">
            <input type="checkbox" name="seeker" [(ngModel)]="roles['Seeker']" (change)="load()">کارجو
          </label>
        </div>
        <div class="mx-1">
          <label class="d-flex align-items-center mx-1">
            <input type="checkbox" name="karpasha" [(ngModel)]="roles['Karpasha']" (change)="load()">کارپاشا
          </label>
        </div>
        <div class="mx-1">
          <label class="d-flex align-items-center mx-1">
            <input type="checkbox" name="employer" [(ngModel)]="roles['Employer']" (change)="load()">کارفرما
          </label>
        </div>
        <label class="d-flex align-items-center mx-1">
          <input type="checkbox" name="agent" [(ngModel)]="roles['Agent']" (change)="load()">کاریابی
        </label>
        <label class="d-flex align-items-center mx-1">
          <input type="checkbox" name="publisher" [(ngModel)]="roles['Publisher']" (change)="load()">ناشر
        </label>
      </div>
      <div class="mx-1">
        <select class="py-1 fs-sm" name="sort" [(ngModel)]="sort" (change)="load()">
          <option [ngValue]="null">مرتب‌سازی</option>
          <option [ngValue]="12">ثبت کاربر</option>
          <option [ngValue]="3">بروزرسانی کاربر</option>
          <option [ngValue]="11">ثبت رزومه</option>
          <option [ngValue]="4">بروزرسانی رزومه</option>
          <option [ngValue]="10">فعال سازی کارجوی پیشتاز</option>
        </select>
      </div>
    </div>
    <div>
      <div class="mx-1 d-flex align-items-center" *ngIf="roles['Seeker']">
        <label class="d-flex align-items-center mx-1">
          <input type="checkbox" name="seeker-promoted" [(ngModel)]="promotedSeeker" (change)="load()"> کارجوی
          پیشتاز
        </label>
        <div>
          <select class="mx-1" name="is-promoted" [(ngModel)]="seekerPromoteIsProcessed" (change)="load()">
            <option [ngValue]="undefined"> همه رزومه ها</option>
            <option [ngValue]="true">بازبینی شده</option>
            <option [ngValue]="false">بازبینی نشده</option>
          </select>
        </div>

      </div>
      <div class="mx-1" *ngIf="roles['Employer']">
        <select name="is-promoted" [(ngModel)]="isPromoted" (change)="load()">
          <option [ngValue]="undefined"> همه کارفرمایان</option>
          <option [ngValue]="true">شرکت های مهم</option>
          <option [ngValue]="false">کارفرمایان عادی</option>
        </select>
      </div>

    </div>
  </form>
  <div class="d-flex flex-wrap align-items-center justify-content-between ">
    <app-pagination [total]="total" [limit]="limit" (page)="load($event)"></app-pagination>
    <div class="mx-1">
      <input type="button" class="btn btn-secondary btn-sm" value="کاربر جدید" (click)="newuser()">
    </div>

  </div>
  <hr>
  <section class="kp-spinner-container-lg">
    <ngx-spinner name="search" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
    <div class="row kp-card mx-0 pb-0" *ngFor="let user of users">
      <ngx-spinner [name]="'action-'+user.Id" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
      <div class="col-12">
        <div>
          <header class="d-flex align-items-center justify-content-between fs-sm f-gray row mb-1">
            <span class="f-blue">ثبت کاربر: {{user.CreateDate|pdate}}</span>
            <span class="f-green">بروزرسانی کاربر: {{(user.LastUpdate)|pdate}}</span>
            <span class="f-green" *ngIf="user.Seeker?.RegisterTime">ثبت رزومه:
              {{user.Seeker?.RegisterTime|pdate}}</span>
            <span class="f-green" *ngIf="user.Seeker?.LastUpdate">بروزرسانی رزومه:
              {{user.Seeker?.LastUpdate|pdate}}</span>
            <span class="f-vanguard" *ngIf="!user.Seeker?.ExpiredPromote && user.Seeker?.PromoteDate">خرید پیشتاز:
              {{(user.Seeker.PromoteDate || user.LastUpdate)|pdate}}</span>
            <span class="mx-1" *ngIf="user.Seeker?.Code">کد رزومه: {{user.Seeker.Code}}</span>
            <span class="mx-1" *ngIf="user.Employer?.Code">کد کارفرما: {{user.Employer.Code}}</span>
          </header>
          <div class="row mb-2">
            <div class="col">
              <div class="d-flex align-items-center">
                <input *ngIf="!user.Username" type="text" name="name" [(ngModel)]="user.Name">
                <h6 class="m-0" *ngIf="user.Username">{{user.Name}} <ng-container *ngIf="user.Employer?.Company">(شرکت
                    {{user.Employer?.Company}})</ng-container>
                </h6>
                <div class="d-flex align-items-center mx-2 fw-bold">
                  <span class="fsp-1 pointer" copy>{{user.Username}}</span>
                  <i class="fa fa-edit pointer mr-2" (click)="selectedUser = user;changeUsernameModal.open()"></i>
                  <app-whatsapp-message class="mr-2 fs-xl" [mobile]="user.Username"
                    text="سلام. وقتتون بخیر. از پشتیبانی سایت کارپیشه (karpishe.com) در خدمت شما هستم.">
                  </app-whatsapp-message>
                </div>
                <div class="d-flex mx-2">
                  <div class="badge f-white blue-bg ml-2" *ngIf="user.Employer && user.Employer?.IsPromoted">شرکت معتبر
                  </div>
                  <div class="badge vanguard-bg f-white ml-2" *ngIf="user.Seeker && !user.Seeker?.ExpiredPromote">کارجوی
                    پیشتاز</div>
                </div>
              </div>
            </div>
            <div class="col text-left">
              <div *ngIf="user.Username" class="d-inline-block mx-2 fs-sm">
                <span (click)="generateCode(user)">تولید کد ورود <i class="fa fa-sign-in-alt fs-sm"></i></span>
                <a class="link mx-1 border p-1" target="_blank" *ngIf="user._code"
                  [routerLink]="['/login',{mobile:user.Username,code:user._code}]">{{user._code}}</a>
              </div>
              <a class="btn btn-secondary btn-sm fs-sm mr-2" target="_blank"
                [routerLink]="['/', 'admin', 'user', user.Id]">ویرایش</a>
              <a class="btn btn-secondary btn-sm fs-sm mr-2" target="_blank" [routerLink]="['/', 'admin', 'payments']"
                [queryParams]="{q: user.Id}">پرداخت ها</a>
              <a class="btn btn-primary btn-sm fs-sm mr-2" (click)="save(user)">ذخیره تغییرات</a>
            </div>
          </div>
          <!-- tabs -->
          <div class="row">
            <div class="container d-flex fs-sm w-100 overflow-auto">
              <div class="kp-tab-item " [class.active]="tabs[user.Id]=='acc'" (click)="tab(user.Id, 'acc')">
                دسترسی‌ها
              </div>
              <div class="kp-tab-item " *ngIf="current.Operator.AccessRights.includes('Financial')"
                [class.active]="tabs[user.Id]=='credit'" (click)="tab(user.Id, 'credit')">
                اعتبار
              </div>
              <div class="kp-tab-item " *ngIf="user.Seeker" [class.active]="tabs[user.Id]=='seeker'"
                (click)="tab(user.Id, 'seeker')">
                رزومه
              </div>
              <div class="kp-tab-item " *ngIf="user.Karpasha" [class.active]="tabs[user.Id]=='karpasha'"
                (click)="tab(user.Id, 'karpasha')">
                کارپاشا
              </div>
              <div class="kp-tab-item " *ngIf="user.Employer" [class.active]="tabs[user.Id]=='employer'"
                (click)="tab(user.Id, 'employer')">
                کارفرما
              </div>
              <div class="kp-tab-item " *ngIf="user.Agent" [class.active]="tabs[user.Id]=='agent'"
                (click)="tab(user.Id, 'agent')">
                کاریابی
              </div>
              <div class="kp-tab-item " *ngIf="user.Publisher" [class.active]="tabs[user.Id]=='publisher'"
                (click)="tab(user.Id, 'publisher')">
                ناشر
              </div>
              <div class="kp-tab-item " [class.active]="tabs[user.Id]=='messages'" (click)="tab(user.Id, 'messages')">
                پیام‌ها
              </div>
              <div class="kp-tab-item " [class.active]="tabs[user.Id]=='actions'" (click)="tab(user.Id, 'actions')">
                رویدادها
              </div>
              <div class="kp-tab-item " [class.active]="tabs[user.Id]=='webpush'" (click)="tab(user.Id, 'webpush')">
                Push
              </div>
              <div class="kp-tab-item " [class.active]="tabs[user.Id]=='activity'" (click)="tab(user.Id, 'activity')">
                فعالیت‌ها
              </div>
            </div>
            <div *ngIf="tabs[user.Id]" class="w-100 border-bottom border-dark-gray" style="margin-top: -1px;"></div>
          </div>
          <div class="row pt-3" *ngIf="tabs[user.Id]">
            <div class="col" *ngIf="tabs[user.Id]=='acc'">
              <div class="row">
                <div class="col">
                  <div>
                    <h6>نقش کاربر</h6>
                    <div class="form-group group-box">
                      <label *ngIf="current.Operator.AccessRights.includes('ManageAccessRights')">
                        <input type="checkbox" name="roles" [disabled]="user.Operator" [checked]="user.Operator"
                          (change)="user.Operator={AccessRights:[]}">
                        اپراتور
                        <span *ngIf="user.Operator?.Disabled">[غیرفعال]</span>
                      </label>
                      <label>
                        <input type="checkbox" name="roles" [disabled]="user.Karpasha" [checked]="user.Karpasha"
                          (change)="user.Karpasha={}">
                        کارپاشا
                        <span *ngIf="user.Karpasha?.Disabled">[غیرفعال]</span>
                      </label>
                      <label>
                        <input type="checkbox" name="roles" [disabled]="user.Agent" [checked]="user.Agent"
                          (change)="user.Agent={}">
                        کاریابی
                        <span *ngIf="user.Agent?.Disabled">[غیرفعال]</span>
                      </label>
                      <label>
                        <input type="checkbox" name="roles" [disabled]="user.Employer" [checked]="user.Employer"
                          (change)="user.Employer={}">
                        کارفرما
                        <span *ngIf="user.Employer?.Disabled">[غیرفعال]</span>
                      </label>
                      <label>
                        <input type="checkbox" name="roles" [disabled]="user.Seeker" [checked]="user.Seeker"
                          (change)="user.Seeker={}">
                        کارجو
                        <span *ngIf="user.Seeker?.Disabled">[غیرفعال]</span>
                      </label>
                      <label>
                        <input type="checkbox" name="roles" [disabled]="user.Publisher" [checked]="user.Publisher"
                          (change)="user.Publisher={}">
                        ناشر
                        <span *ngIf="user.Publisher?.Disabled">[غیرفعال]</span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col" *ngIf="current.Operator.AccessRights.includes('ManageAccessRights') && user.Operator">
                  <div class="kp-form-row">
                    <h6>دسترسی های اپراتور</h6>
                    <div class=" form-group group-box">
                      <label>
                        <input type="checkbox" name="types"
                          [checked]="hasKey(user.Operator.AccessRights,'ManageAccessRights')"
                          (change)="setKey(user.Operator,'ManageAccessRights',$event,'AccessRights')">
                        <span>مدیریت دسترسی ها</span>
                      </label>
                      <label>
                        <input type="checkbox" name="types"
                          [checked]="hasKey(user.Operator.AccessRights,'TechnicalSupport')"
                          (change)="setKey(user.Operator,'TechnicalSupport',$event,'AccessRights')">
                        <span>پشتیبانی فنی</span>
                      </label>
                      <label>
                        <input type="checkbox" name="types" [checked]="hasKey(user.Operator.AccessRights,'ManageLeads')"
                          (change)="setKey(user.Operator,'ManageLeads',$event,'AccessRights')">
                        <span>مدیریت سرنخ‌ها (راهبر)</span>
                      </label>
                      <label>
                        <input type="checkbox" name="types" [checked]="hasKey(user.Operator.AccessRights,'ManageJobs')"
                          (change)="setKey(user.Operator,'ManageJobs',$event,'AccessRights')">
                        <span>مدیریت آگهی‌ها</span>
                      </label>
                      <label>
                        <input type="checkbox" name="types" [checked]="hasKey(user.Operator.AccessRights,'Reports')"
                          (change)="setKey(user.Operator,'Reports',$event,'AccessRights')">
                        <span>گزارش ها</span>
                      </label>
                      <label>
                        <input type="checkbox" name="types"
                          [checked]="hasKey(user.Operator.AccessRights,'ManageContents')"
                          (change)="setKey(user.Operator,'ManageContents',$event,'AccessRights')">
                        <span>مدیریت محتوا</span>
                      </label>
                      <label>
                        <input type="checkbox" name="types" [checked]="hasKey(user.Operator.AccessRights,'ManageUsers')"
                          (change)="setKey(user.Operator,'ManageUsers',$event,'AccessRights')">
                        <span>مدیریت کاربران</span>
                      </label>
                      <label>
                        <input type="checkbox" name="types"
                          [checked]="hasKey(user.Operator.AccessRights,'ManageSeekers')"
                          (change)="setKey(user.Operator,'ManageSeekers',$event,'AccessRights')">
                        <span>مدیریت کارجویان</span>
                      </label>
                      <label>
                        <input type="checkbox" name="types"
                          [checked]="hasKey(user.Operator.AccessRights,'ManageAgents')"
                          (change)="setKey(user.Operator,'ManageAgents',$event,'AccessRights')">
                        <span>مدیریت کاریابی</span>
                      </label>
                      <label>
                        <input type="checkbox" name="types"
                          [checked]="hasKey(user.Operator.AccessRights,'ManageBoards')"
                          (change)="setKey(user.Operator,'ManageBoards',$event,'AccessRights')">
                        <span>مدیریت ناشران</span>
                      </label>
                      <label>
                        <input type="checkbox" name="types"
                          [checked]="hasKey(user.Operator.AccessRights,'ManageDocuments')"
                          (change)="setKey(user.Operator,'ManageDocuments',$event,'AccessRights')">
                        <span>مدیریت فروشگاه</span>
                      </label>
                      <label>
                        <input type="checkbox" name="types" [checked]="hasKey(user.Operator.AccessRights,'Financial')"
                          (change)="setKey(user.Operator,'Financial',$event,'AccessRights')">
                        <span>مالی</span>
                      </label>
                      <label>
                        <input type="checkbox" name="types" [checked]="hasKey(user.Operator.AccessRights,'Legal')"
                          (change)="setKey(user.Operator,'Legal',$event,'AccessRights')">
                        <span>حقوقی</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" *ngIf="user.Seeker || user.Employer">
                <div class="col">
                  <h6>تبدیل سرویس</h6>
                  <div class="d-flex">
                    <select #transmitFrom class="form-control" name="transmit-from">
                      <option value="">تبدیل از</option>
                      <option *ngIf="!user.Seeker?.ExpiredPromote" value="vanguard">کارجوی پیشتاز</option>
                      <option *ngIf="user.Seeker?.KarpashaProgress?.IsPaid" value="karpasha">ثبت نام کاریابی</option>
                      <option *ngIf="user.Employer?.Disabled==false" value="employer">کارفرما</option>
                    </select>
                    <select #transmitTo class="form-control" name="transmit-from">
                      <option value="">تبدیل به</option>
                      <option *ngIf="transmitFrom.value!='vanguard'" value="vanguard">کارجوی پیشتاز</option>
                      <option *ngIf="transmitFrom.value!='karpasha'" value="karpasha">ثبت نام کاریابی</option>
                      <option *ngIf="transmitFrom.value!='employer'" value="employer">کارفرما</option>
											<option value="ready-to-work">آگهی آماده به کار</option>
                    </select>
                    <button class="btn btn-secondary mx-1"
                      (confirm)="transmit(user, transmitTo.value, transmitFrom.value)">تبدیل</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="col" *ngIf="tabs[user.Id]=='credit'">
              <div class="container">
                <h6 (click)="user._setcredit=true">اعتبار: {{user.Credit|number}} تومان<ng-container
                    *ngIf="user._setcredit && user._credit"> => {{user.Credit+user._credit|number}}</ng-container>
                </h6>
                <div *ngIf="user._setcredit" class="row">
                  <div class="col-8 p-1"><input type="number" inputmode="numeric" dir="ltr"
                      [(ngModel)]="user._credit" /></div>
                  <div class="col-4 p-1"><a class="btn btn-gray" (click)="addCredit(user)">تغییر اعتبار</a></div>
                </div>
              </div>
              <div class="container">
                <h6 (click)="user._setResumeCredit=true">اعتبار رزومه: {{user.ResumeCredit|number}} عدد<ng-container
                    *ngIf="user._setResumeCredit && user._resumeCredit"> =>
                    {{user.ResumeCredit + user._resumeCredit |number}}</ng-container>
                </h6>
                <div *ngIf="user._setResumeCredit" class="row">
                  <div class="col-8 p-1"><input type="number" inputmode="numeric" dir="ltr"
                      [(ngModel)]="user._resumeCredit" /></div>
                  <div class="col-4 p-1"><a class="btn btn-gray" (click)="addResumeCredit(user)">تغییر اعتبار
                      رزومه</a></div>
                </div>
              </div>
              <div class="container">
                <h6 (click)="user._setNotCompletedResumeCredit=true">اعتبار کارجوی گوش به زنگ:
                  {{user.NotCompletedResumeCredit|number}} عدد<ng-container
                    *ngIf="user._setNotCompletedResumeCredit && user._NotCompletedResumeCredit"> =>
                    {{user.NotCompletedResumeCredit + user._NotCompletedResumeCredit |number}}</ng-container>
                </h6>
                <div *ngIf="user._setNotCompletedResumeCredit" class="row">
                  <div class="col-8 p-1"><input type="number" inputmode="numeric" dir="ltr"
                      [(ngModel)]="user._NotCompletedResumeCredit" /></div>
                  <div class="col-4 p-1"><a class="btn btn-gray" (click)="addNotCompletedResumeCredit(user)">تغییر
                      اعتبار
                      کارجوی گوش به زنگ</a></div>
                </div>
              </div>
            </div>
            <div class="col" *ngIf="tabs[user.Id]=='seeker'">
              <div class="d-flex justify-content-between">
                <div>
                  <div class="f-green">تکمیل اطلاعات: {{user.Seeker.Completeness}}% <a class="btn btn-link f-blue"
                      *ngIf="user.Seeker" [routerLink]="['/resume', user.Seeker.Code]" target="_blank">
                      مشاهده رزومه</a>
                  </div>
                  <div class="d-flex align-items-center">
                    <div class="f-red" *ngIf="user.Seeker.ExpiredPromote">بسته کارجوی پیشتاز ندارد یا منقضی شده</div>
                    <div class="border mx-1" *ngIf="!user.Seeker.ExpiredPromote">
                      <div class="f-green">انقضای کارجوی پیشتاز: {{user.Seeker.PromoteUntil|pdate}}</div>
                      <button class="btn btn-secondary btn-sm mx-1 fs-sm"
                        (click)="stopVanguardModal.open();calculateStopVanguard(user)">توقف پیشتاز</button>
                    </div>
                    <div class="border mx-1" *ngIf="user.Seeker.KarpashaProgress"
                      [ngSwitch]="user.Seeker.KarpashaProgress.Status">
                      <ng-container class="f-green">وضعیت کارپاشا:
                        <span *ngSwitchCase="0">در حال اجرا</span>
                        <span *ngSwitchCase="1">کنسل شده</span>
                        <span *ngSwitchCase="2">معلق شده</span>
                        <span *ngSwitchCase="3">تکمیل شده</span>
                        <span *ngIf="user.Seeker.KarpashaProgress.IsPaid">پرداخت کرده</span>
                      </ng-container>
                      <button class="btn btn-secondary btn-sm mx-1 fs-sm" *ngIf="user.Seeker.KarpashaProgress.Status!=1"
                        (confirm)="stopKarpasha(user.Id);">توقف کارپاشا</button>
                    </div>
                  </div>
                </div>
                <div>
                  <div>
                    <label class="d-inline-block mx-2" *ngIf="user.Seeker.JobAlertSettings">
                      <input type="checkbox" name="alertDisabled" [(ngModel)]="user.Seeker.JobAlertSettings.Disabled">
                      آلرت ارسال نشود
                    </label>
                  </div>
                  <div>
                    <label class="d-inline-block mx-2">
                      <input type="checkbox" name="seekerDisabled" [(ngModel)]="user.Seeker.Disabled">
                      رزومه غیر فعال شود
                    </label>
                  </div>
                </div>
              </div>
              <div class="d-flex">
                <div>
                  <app-resume [code]="user.Seeker?.Code" [showSubscriptions]="true" class="d-block"></app-resume>
                </div>
                <div class="flex-fill kp-card kp-card-border">
                  <div class="border-bottom pb-2 mb-2">
                    <h6>سابسکرایب ها</h6>
                    <div>
                      <span class="badge badge-light mx-1"
                        *ngFor="let search of user.Seeker?.JobAlertSettings.Searches">
                        "{{search.Keyword}}" در [{{search.Location.State}}، {{search.Location.City}}]
                      </span>
                    </div>
                  </div>
                  <div class="border-bottom pb-2 mb-2">
                    <h6>تگ‌های جاب تایتل <button class="btn btn-secondary btn-sm fs-sm"
                        (click)="tagJobTitle(user)">محاسبه مجدد</button></h6>
                    <div class="d-flex flex-wrap ">
                      <div class="badge dark-gray-bg f-yellow fs-normal m-1 no-wrap "
                        *ngFor="let jt of user.Seeker?._metaJobTitleTags">
                        {{jt.Title}} - {{jt.Relevance}}
                      </div>
                    </div>
                  </div>
                  <div class="border-bottom pb-2 mb-2">
                    <h6>Suggest <button class="btn btn-secondary btn-sm fs-sm" (click)="getSuggestions(user)">محاسبه
                        مجدد</button></h6>
                    <div *ngIf="user.Seeker?._suggestions">
                      <h5>positions</h5>
                      <div class="d-flex flex-wrap ">
                        <div class="badge dark-gray-bg f-yellow fs-normal m-1 no-wrap"
                          *ngFor="let item of user.Seeker?._suggestions?.positions"> {{item.Key}}: {{item.Score}} </div>
                      </div>
                      <h5>searches</h5>
                      <div class="d-flex flex-wrap ">
                        <div class="badge dark-gray-bg f-yellow fs-normal m-1 no-wrap"
                          *ngFor="let item of user.Seeker?._suggestions?.searches"> {{item.Key}}: {{item.Score}} </div>
                      </div>
                      <h5>skills</h5>
                      <div class="d-flex flex-wrap ">
                        <div class="badge dark-gray-bg f-yellow fs-normal m-1 no-wrap"
                          *ngFor="let item of user.Seeker?._suggestions?.skills"> {{item.Key}}: {{item.Score}} </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <div class="col" *ngIf="tabs[user.Id]=='employer'">
              <app-edit-employer [userId]="user.Id"></app-edit-employer>
            </div>
            <div class="col d-flex flex-wrap justify-content-between" *ngIf="tabs[user.Id]=='agent'">
              <label>
                نام کاریابی
                <input type="text" name="types" [(ngModel)]="user.Agent.Company">
              </label>
              <label>
                شهر، استان
                <app-location name="location" [(ngModel)]="user.Agent"></app-location>
              </label>
              <label>
                محله
                <input type="text" name="types" [(ngModel)]="user.Agent.District">
              </label>
              <label>
                آدرس
                <input type="text" name="types" [(ngModel)]="user.Agent.Address">
              </label>
              <label>
                تلفن‌ها
                <ng-select name="phones" [multiple]="true" [(ngModel)]="user.Agent.Phones" addTagText="افزودن"
                  [selectOnTab]="true" [inputAttrs]="{type:'phone'}" [addTag]="addTag">
                </ng-select>
              </label>
              <label>
                <input type="checkbox" name="is-partner" [(ngModel)]="user.Agent.IsPartner">
                همکار
              </label>
              <label>
                فرصت‌های شغلی
                <ng-select name="jobtitles" [multiple]="true" [(ngModel)]="user.Agent.JobTitles" addTagText="افزودن"
                  [selectOnTab]="true" [addTag]="addTag">
                </ng-select>
              </label>

              <!-- <div class="row">
                <div class="col">
                  <label>
                    <input type="checkbox" name="is-trusted" [(ngModel)]="user.Agent.IsTrusted">
                    انتشار آگهی‌ها بدون نیاز به تایید اپراتور
                  </label>
                  <label>
                    <input type="checkbox" name="is-legal" [(ngModel)]="user.Agent.IsLegal">
                    نوع کاریابی حقوقی
                  </label>
                </div>
                <label class="col">
                  درصد پورسانت
                  <input type="number" inputmode="numeric" name="percentage" placeholder="درصد پورسانت"
                    [(ngModel)]="user.Agent.Percentage"></label>
              </div> -->
            </div>
            <div class="col" *ngIf="tabs[user.Id]=='karpasha'">
              تنطیمات کارپاشا
            </div>
            <div class="col" *ngIf="tabs[user.Id]=='publisher'">
              <div class="row">
                <label class="col">
                  درصد پورسانت
                  <input type="number" inputmode="numeric" name="percentage" placeholder="درصد پورسانت"
                    [(ngModel)]="user.Publisher.Percentage"></label>
              </div>
            </div>
            <div class="col pb-2" *ngIf="tabs[user.Id]=='messages'">
              <div>
                <label>
                  <h6>کانال ترجیحی ارسال پیام</h6>
                  <select [(ngModel)]="user.PreferredChannel">
                    <option value="">پیش‌فرض</option>
                    <option [value]="0">Push</option>
                    <option [value]="1">Sms</option>
                    <option [value]="2">Email</option>
                  </select>
                </label>
                <div class="btn btn-secondary btn-sm" (click)="loadMessages(user)">دریافت پیام‌ها</div>
              </div>
              <div class="container-capped overflow-auto" style="max-height: 500px;">
                <div class="kp-card" *ngFor="let message of user._messages">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="badge">
                      <ng-container [ngSwitch]="message.SentChannel">
                        <ng-container *ngSwitchCase="0">Push</ng-container>
                        <ng-container *ngSwitchCase="1">SMS</ng-container>
                        <ng-container *ngSwitchCase="2">Email</ng-container>
                        <ng-container *ngSwitchDefault></ng-container>
                      </ng-container>
                    </div>

                    <div class="badge">{{message.SentDate|pdate}}</div>
                    <div class="badge">
                      <ng-container [ngSwitch]="message.Type">
                        <ng-container *ngSwitchCase="0">پیامک ورود</ng-container>
                        <ng-container *ngSwitchCase="1">آلرت آگهی ویژه</ng-container>
                        <ng-container *ngSwitchCase="2">آلرت کارجوی پیشتاز</ng-container>
                        <ng-container *ngSwitchCase="3">Matching</ng-container>
                        <ng-container *ngSwitchCase="4">NoMatching</ng-container>
                        <ng-container *ngSwitchCase="5">ارتباط با کارفرما</ng-container>
                        <ng-container *ngSwitchCase="6">ارتباط با کارجو</ng-container>
                        <ng-container *ngSwitchDefault></ng-container>
                      </ng-container>
                      - {{message.SubType}}
                    </div>
                  </div>
                  <div class="p-2 pre-wrap">
                    <ng-container *ngIf="message.Title">
                      <h6>{{message.Title}}</h6>
                      <hr />
                    </ng-container>
                    {{message.Text}}
                    <hr />
                    {{message.Link}}
                  </div>
                </div>
              </div>
            </div>
            <div class="col pb-2" *ngIf="tabs[user.Id]=='webpush'">
              <div class="d-flex flex-wrap">
                <div class="container-capped-xs">
                  <textarea dir="ltr" class="fs-sm lh-1" rows="10" [(ngModel)]="pushString"></textarea>
                  <div class="btn btn-secondary btn-sm" (click)="sendPush(user)">ارسال</div>

                </div>
                <div class="flex-fill overflow-auto" style="max-height: 90vh;">
                  <div>
                    <div class="btn btn-secondary btn-sm" (click)="loadPushTokens(user)">دریافت توکن ها</div>
                  </div>
                  <div class="d-flex flex-wrap">
                    <div class="kp-card w-100 overflow-auto fs-sm" *ngFor="let token of user._pushTokens">
                      <div class="text-left">
                        <div class="btn btn-secondary btn-sm" (click)="sendPush(user, token.Id)">ارسال</div>
                      </div>
                      <div (click)="token._expanded=!token._expanded">{{token.Id}}
                        <br />
                        {{token.Token}}
                      </div>
                      <pre class="text-left" dir="ltr" *ngIf="token._expanded">{{token | json}}</pre>
                    </div>
                  </div>

                </div>

              </div>
            </div>
            <div class="col pb-2" *ngIf="tabs[user.Id]=='activity'">
              <app-activity [inline]="true" [user]="user.Id" [limit]="1000"></app-activity>
            </div>
            <div class="col pb-2" *ngIf="tabs[user.Id]=='actions'">
              <div>
                <div class="btn btn-secondary btn-sm" (click)="loadActions(user)">دریافت رویدادها</div>
              </div>
              <div class="container-capped overflow-auto" style="max-height: 500px;">
                <div class="kp-card" *ngFor="let action of user._actions">
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="badge">
                      {{action.TimeStamp | pdate}}
                    </div>
                    <div class="badge">
                      {{action.IP}}
                    </div>
                  </div>
                  <div class="">
                    action: {{action.Action}}, category: {{action.Category}}, label: {{action.Label}}, value:
                    {{action.Value}}
                  </div>
                  <div dir="ltr">
                    {{action.Url}}
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </section>
</section>
<ngx-smart-modal customClass="" #stopVanguardModal identifier="stopVanguardModal">
  <ngx-spinner name="stop-vanguard" [fullScreen]="false" type="timer"></ngx-spinner>
  <form class="container-sm py-5" *ngIf="stopVanguardData">
    <table>
      <tr>
        <td>
          <h6>مبلغ پرداخت شده:</h6>
        </td>
        <td>{{stopVanguardData.paid | number}} تومان</td>
      </tr>
      <tr>
        <td>
          <h6>تعداد روز:</h6>
        </td>
        <td>{{stopVanguardData.days | number}}</td>
      </tr>
      <tr>
        <td>
          <h6>هزینه روزانه:</h6>
        </td>
        <td>{{stopVanguardData.pricePerDay | number}} تومان</td>
      </tr>
      <tr>
        <td>
          <h6>روزهای باقیمانده:</h6>
        </td>
        <td>{{stopVanguardData.remainingDays | number}}</td>
      </tr>
      <tr>
        <td>
          <h6>مبلغ باقیمانده:</h6>
        </td>
        <td>
          <input type="number" name="remainingDays" [(ngModel)]="stopVanguardData.remaining">
          تومان
        </td>
      </tr>
    </table>
    <div>
      <button class="btn btn-link" (click)="stopVanguardModal.close()">انصراف</button>
      <button class="btn btn-primary"
        (click)="vanguardClearance(stopVanguardData.userId, stopVanguardData.remaining)">تایید</button>
    </div>

  </form>
</ngx-smart-modal>
<ngx-smart-modal customClass="" #changeUsernameModal identifier="changeUsernameModal">
  <ngx-spinner name="change-username" [fullScreen]="false" type="timer"></ngx-spinner>
  <div class="container-sm py-5" *ngIf="selectedUser">
    <div class="border p-1 m-2 rounded-xl">
      <label>
        <h6>شماره یا نام کاربری جدید</h6>
        <input type="text" dir="ltr" #newUsernameInput name="username" />
      </label>
      <label>
        <input type="checkbox" name="notMobile" #notMobile>موبایل نیست
      </label>
      <button class="btn btn-primary" (click)="changeUsername(newUsernameInput.value, notMobile.checked)">تغییر نام
        کاربری</button>
    </div>
    <div class="border p-1 m-2 rounded-xl">
      <label>
        <h6>رمز عبور جدید</h6>
        <input type="password" dir="ltr" #passwordInput name="password" placeholder="رمز عبور" />
      </label>
      <button class="btn btn-primary" (click)="changePassword(passwordInput.value)">تغییر رمز عبور</button>
    </div>
  </div>
</ngx-smart-modal>
